var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-award-audit-detail',{staticClass:"pt-award-audit-detail__page",attrs:{"id":_vm.id,"isManualReward":_vm.is_manual_reward}})}
var staticRenderFns = []

export { render, staticRenderFns }